const {KitModule, registerModule} = window;

// no space as it will be triggered from click
const OPEN_SUBNAV_KEYS = ['Enter', 'ArrowDown'];

class Nav extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.$menuCheckbox = document.querySelector('.nav-menu-checkbox');
    this.searchIsOpen = false;
  }

  bindEvents() {
    // events
    this.$element.addEventListener('keydown', this);
    this.$element.addEventListener('click', this);
    this.$menu.addEventListener('mouseover', this);
    this.$menuCheckbox.addEventListener('change', this);
    this.$menuLabel.addEventListener('click', this.onMenuLabelClick.bind(this));
    // browser hack - fire click on touchstart, avoid :hover & focus
    this.$menuLabel.addEventListener('touchstart', function() {});

    window.addEventListener('searchopen', this);
    window.addEventListener('searchclose', this);

    this.bindMediaQuery();

    window.addEventListener('resize', this);
    window.addEventListener('scroll', this);
  }

  // Hide Casepoint text when we scroll

  // onscroll() {
  //   const scrollPos = window.scrollY;
  //   const navHeight = this.$menu.offsetHeight;
  //   const svgPath = this.$branding.querySelector('svg path:last-child');
  //   if (scrollPos > navHeight) {
  //     svgPath.style.opacity = '0';
  //   } else {
  //     svgPath.style.opacity = '1';
  //   }
  // }

  // Hide Casepoint text when we scroll

  onresize() {
    if (this.isDesktop) {
      this.$menuCheckbox.checked = false;
      this.isMenuOpen = this.$menuCheckbox.checked;
      document.documentElement.classList.remove('nav-menu-open', this.isMenuOpen);
    }
  }

  bindMediaQuery() {
    // get media query from custom property
    const rootStyle = getComputedStyle(document.documentElement);

    // max nav - mobile
    const maxQuery = rootStyle.getPropertyValue('--max-nav-media-query');
    this.maxMediaQuery = window.matchMedia(maxQuery);
    // listen and set initial
    this.maxMediaQuery.addEventListener('change', this.onMaxMediaChange.bind(this));
    this.onMaxMediaChange(this.maxMediaQuery);

    // min nav - desktop
    const minQuery = rootStyle.getPropertyValue('--min-nav-media-query');
    this.minMediaQuery = window.matchMedia(minQuery);
    // listen and set initial
    this.minMediaQuery.addEventListener('change', this.onMinMediaChange.bind(this));
    this.onMinMediaChange(this.maxMediaQuery);
  }

  onMaxMediaChange(mobileMediaQuery) {
    this.isMobile = mobileMediaQuery.matches;
  }

  onMinMediaChange(desktopMediaQuery) {
    this.isDesktop = desktopMediaQuery.matches;
  }

  onsearchopen() {
    this.searchIsOpen = true;
    if (this.isMenuOpen) this.$menuCheckbox.click();
  }

  onsearchclose() {
    this.searchIsOpen = false;
    if (this.isMobile) {
      this.closeSubnav();
      if (this.isMenuOpen) this.$menuCheckbox.click();
    }
  }

  // toggle subnav on .nav__item__button click
  onclick(event) {
    const $itemButton = event.target.closest('.nav__item__button');
    if (!$itemButton) return;

    const $item = $itemButton.closest('.nav__item');
    this.toggleSubnav($item);
  }

  onkeydown(event) {
    if (event.key === 'Escape') {
      this.closeSubnav();
      if (this.isMenuOpen) this.$menuCheckbox.click();
      return;
    }
    const isOpeningSubnav = OPEN_SUBNAV_KEYS.includes(event.key) &&
      event.target.matches('.nav__item__button--subnav');

    if (isOpeningSubnav) {
      event.preventDefault();
      const $item = event.target.closest('.nav__item');
      if ($item === this.$openSubnavItem && event.key !== 'ArrowDown') {
        this.closeSubnav();
      } else {
        this.openSubnav($item);
      }
    }
  }

  // close subnav if hovered over other item, desktop only
  onmouseover(event) {
    if (this.isMobile) return;
    const $item = event.target.closest('.nav__item');
    if ($item && $item !== this.$openSubnavItem) this.closeSubnav();
  }

  onchange() {
    this.isMenuOpen = this.$menuCheckbox.checked;
    document.documentElement.classList.toggle('nav-menu-open', this.isMenuOpen);
  }

  // programmatically trigger click to avoid browser setting scroll position to top
  onMenuLabelClick(event) {
    event.preventDefault();

    if (this.searchIsOpen) {
      const customEvent = new Event('menulabelclicked');
      window.dispatchEvent(customEvent);
    }

    this.$menuCheckbox.click();
  }

  openSubnav($item) {
    if (!$item) return;

    this.closeSubnav(this.$openSubnavItem); // close previous

    this.$openSubnavItem = $item;
    this.$openSubnavButton = $item.querySelector('.nav__item__button');
    this.$openSubnavItem.classList.add('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'true');
  }

  closeSubnav() {
    if (!this.$openSubnavItem) return;

    this.$openSubnavItem.classList.remove('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'false');
    this.$openSubnavItem = null;
    this.$openSubnavButton = null;
  }

  toggleSubnav($item) {
    if ($item === this.$openSubnavItem) {
      this.closeSubnav();
    } else {
      this.openSubnav($item);
    }
  }

  unmount() {
    this.$element.removeEventListener('keydown', this);
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
    this.$menu.removeEventListener('mouseover', this);
    this.$menuCheckbox.removeEventListener('change', this);
  }
}

registerModule('Nav', Nav);

// JavaScript to manage session-based popup
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('popup');
  const closePopupButton = document.getElementById('closePopup');

  // Check localStorage to see if the popup was closed and if 24 hours have passed
  const popupClosedAt = localStorage.getItem('popupClosedAt');
  const now = new Date().getTime();

  if (!popupClosedAt || now - popupClosedAt > 24 * 60 * 60 * 1000) {
    // Show the popup if it was not closed or if 24 hours have passed since it was closed
    popup.style.display = 'block';
  }

  // Close button functionality
  if (closePopupButton) {
    closePopupButton.addEventListener('click', () => {
      popup.style.display = 'none';
      // Store the timestamp when the popup is closed
      localStorage.setItem('popupClosedAt', new Date().getTime());
    });
  }
});

/**
 * Updates the heights of the header and dropdown elements.
 *
 * This function calculates the heights of the header and dropdown elements
 * and sets the corresponding CSS variables (`--dynamic-header-height` and
 * `--dynamic-dropdown-height`) to dynamically adjust styles.
 */
function updateHeights() {
  const header = document.querySelector('header');
  const dropdown = document.querySelector('headerbar'); // Fixed selector for 'headerbar'

  let headerHeight = 0;
  let dropdownHeight = 0;

  if (header) {
    // Get the header's visible height (including scrolled portion)
    const headerRect = header.getBoundingClientRect();
    headerHeight = headerRect.height; // The height of the header in view
  }

  if (dropdown) {
    // Calculate visible portion of the dropdown
    const dropdownRect = dropdown.getBoundingClientRect();
    if (dropdownRect.top >= 0) {
      dropdownHeight = dropdownRect.height; // Dropdown fully visible
    } else if (dropdownRect.bottom > 0) {
      dropdownHeight = dropdownRect.bottom; // Dropdown partially visible
    } else {
      dropdownHeight = 0; // Dropdown not visible
    }
  }

  // Subtract dropdown height when scrolled out of view
  const totalNavHeight = headerHeight + dropdownHeight;

  // Set CSS variables dynamically
  if (document.documentElement) {
    document.documentElement.style.setProperty('--total-nav-height', `${totalNavHeight}px`);
    document.documentElement.style.setProperty('--dynamic-header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--dynamic-dropdown-height', `${dropdownHeight}px`);
  }
}

// Call the function initially and on relevant events
document.addEventListener('DOMContentLoaded', updateHeights); // Ensure DOM is loaded
window.addEventListener('resize', updateHeights); // Update on resize
window.addEventListener('scroll', updateHeights); // Update on scroll for partial visibility


document.addEventListener('DOMContentLoaded', () => {
  const searchBar = document.querySelector('.search');
  const header = document.querySelector('.header-bar'); // Adjust selector based on your header

  if (!searchBar || !header) return; // Exit if search bar or header is not found

  const headerHeight = header.offsetHeight; // Get header height for reference

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;

    if (scrollY > headerHeight) {
      // Add the 'scrolled' class when the user scrolls past the header
      searchBar.classList.add('scrolled');
    } else {
      // Remove the 'scrolled' class when at the top
      searchBar.classList.remove('scrolled');
    }
  });
});
